import { render, staticRenderFns } from "./DadosAluno.vue?vue&type=template&id=504933b4&scoped=true&v-if=this.aluno&"
import script from "./DadosAluno.vue?vue&type=script&lang=js&"
export * from "./DadosAluno.vue?vue&type=script&lang=js&"
import style0 from "./DadosAluno.vue?vue&type=style&index=0&id=504933b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504933b4",
  null
  
)

export default component.exports